/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useReducer } from "react";

export function useToggle(initialValue = false) {
  return useReducer((prevValue) => !prevValue, initialValue);
}
